module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"EntryModal":{"button":"Pokračovat","heading":"Pozor! Stránka je pro dospělé.","text":"Pokračováním potvrzujete, že jste starší 18 let."}}}')
  delete Component.options._Ctor
}
